<template>
  <el-dialog
    class="rooms-dialog"
    :visible.sync="isShowDeleteDialog"
    width="450px"
    :before-close="() => (isShowDeleteDialog = false)"
    :modal-append-to-body="false"
  >
    <div class="rooms-dialog_hd">
      <i class="el-icon-info" />
      <div class="rooms-dialog_hd_text">
        <p class="dialog_hd_text_title">{{ msg }}</p>
      </div>
    </div>
    <div class="rooms-dialog_btnList">
      <div class="rooms-dialog_btn blue-btn" @click="() => (isShowDeleteDialog = false)">
        <span>{{ $t('install.getInfo') }}</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'RoomsDialog',
  data() {
    return {
      isShowDeleteDialog: false,
      msg: '',
    }
  },
  methods: {
    show(msg) {
      this.isShowDeleteDialog = true
      this.msg = msg
    },
  },
}
</script>
<style lang="scss" scoped>
.rooms-dialog {
  ::v-deep .el-dialog {
    width: 480px;
    top: 20%;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 15px;
    .rooms-dialog_hd {
      display: flex;
    }

    .el-icon-info {
      transform: translateY(3px);
      margin-right: 10px;
      font-size: 20px;
    }
    .dialog_hd_text_title {
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: normal;
      line-height: 26px;
      color: #595959;
    }
    .marginTop {
      margin-top: 8px;
    }
  }
}
.rooms-dialog_btnList {
  display: flex;
  padding-top: 30px;
  justify-content: flex-end;
  .rooms-dialog_btn {
    width: 120px;
    padding: 5px 6px;
    border-radius: 4px;
    min-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    border: 1px solid #d7d7d7;
    cursor: pointer;
    &.blue-btn {
      background-color: #0046aa;
      color: #fff;
      border: 0px solid #d7d7d7;
    }
    span {
      text-align: center;
    }
  }
}
</style>
